import { apiFetch } from "../fetchApi";
export const createStatus = async (BeURL, showAlert, payload, setStatus) => {
    try {
        // 2️⃣ Send companyId as query param for account creation
        const accountRes = await apiFetch(`${BeURL}/create-status`, {
            method: "POST",
            body: JSON.stringify(payload),
        });

        const accountData = await accountRes.json();
        if (!accountData.success) {
            showAlert(accountData.message);
            return;
        }


        showAlert(accountData.message);
        setStatus({
            statusName: '',
            active: true
        })


    } catch (err) {
        console.error("Error in Status create:", err);
        alert('Trouble connecting to the server! Please try again later.');
    }
};

export const fetchStatusId = async (BeURL, showAlert, setStatus, id) => {
    try {
        // 2️⃣ Send companyId as param for get manager Ids creation
        const res = await apiFetch(`${BeURL}/status/${id}`, {
            method: "GET",
        });

        const data = await res.json();
        if (!data.success) {
            showAlert(data.message);
           
        }

        setStatus(
            {
                statusName: data.status.status,
                active: data.status.isActive
            })


    } catch (err) {
        console.error("Error in Fetch Status Id:", err);
        alert('Trouble connecting to the Status ID Ftech! Please try again later.');
    }
}

export const fetchStatus = async (BeURL, showAlert, setStatus) => {
    try {
        // 2️⃣ Send companyId as param for get manager Ids creation
        const res = await apiFetch(`${BeURL}/allStatus`, {
            method: "GET",

        });

        const data = await res.json();
       
        if (!data.success) {
            showAlert(data.message);
            return;
        }

        setStatus(data.status)


    } catch (err) {
        console.error("Error in Fetch All Status:", err);
        alert('Trouble connecting to the server! Please try again later.');
    }
}

export const updateStatus = async (BeURL, showAlert, payload, setStatus, id) => {
    try {


        
        const accountRes = await apiFetch(`${BeURL}/update-status/${id}`, {
            method: "POST",
            body: JSON.stringify(payload), // FormData (images/files)
        });

        const accountData = await accountRes.json();
        if (!accountData.success) {
            showAlert(accountData.message);
            return;
        }

        showAlert(accountData.message);
        setStatus({
            statusName: '',
            active: true
        })
        window.location.reload()


    } catch (err) {
        console.error("Error in Status Update:", err);
        alert('Trouble connecting to the server update status! Please try again later.');
    }
};

export const deleteStatus = async (BeURL, showAlert, id) => {
    try {
        // 2️⃣ Send companyId as param for get manager Ids creation
        const res = await apiFetch(`${BeURL}/delete-status/${id}`, {
            method: "DELETE",
        });

        const data = await res.json();
        if (!data.success) {
            showAlert(data.message);
            return;
        }

        showAlert(data.message)
        window.location.reload()


    } catch (err) {
        console.error("Error in Delete client :", err);
        alert('Trouble connecting to the server! Please try again later.');
    }
}